import { BookingSub } from 'interface/BookingSub';
import axiosInstance from '../axios/axiosInstance';

export const BOOKING_SUB_SIZE = 9;

export const getBookingSubs = async (url?: string) => {
  const { data } = await axiosInstance.get<any>(url || '/booking-sub', { params: { fromCMS: true } });
  return data;
};

export const getBookingSubById = async (id?: string) => {
  const { data } = await axiosInstance.get<BookingSub>(`/booking-sub/${id}`);
  return data;
};

export const deleteBookingSubById = async (id?: string) => {
  const { data } = await axiosInstance.delete<void>(`/booking-sub/${id}`);
  return data;
};

export const updateBookingSubById = async (id?: string, payload?: BookingSub) => {
  const { data } = await axiosInstance.put<void>(`/booking-sub/${id}`, payload);
  return data;
};
